var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 36",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "ulc6mjp85__ruohydc4za"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6363",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3648",
    offset: "99.921636%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.143906,15.376262 C32.143906,7.012568 25.363694,0.232356 17,0.232356 C8.636238,0.232356 1.856094,7.012568 1.856094,15.376262 C1.856094,20.280864 4.188324,24.640072 7.803544,27.407638 L7.801776,27.407638 L7.819864,27.42015 C8.197808,27.708708 17,33.767644 17,33.767644 C17,33.767644 25.80226,27.70864 26.180272,27.420014 L26.197272,27.408284 L26.195606,27.408284 C29.811302,24.640786 32.143906,20.281238 32.143906,15.376262 Z",
    stroke: "#FFF",
    fill: "url(#ulc6mjp85__ruohydc4za)",
    fillRule: "nonzero",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 14,
    fontWeight: 500,
    fill: "#FFF",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 20.8666667
  }, "\u7B7E")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.a70df4208934397e186b861d6e02dbcf.svg";
export { ForwardRef as ReactComponent };